import { render, staticRenderFns } from "./ISAStatfalseAlertsCount.vue?vue&type=template&id=04cc88f6&scoped=true&"
import script from "./ISAStatfalseAlertsCount.vue?vue&type=script&lang=js&"
export * from "./ISAStatfalseAlertsCount.vue?vue&type=script&lang=js&"
import style0 from "./ISAStatfalseAlertsCount.vue?vue&type=style&index=0&id=04cc88f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cc88f6",
  null
  
)

export default component.exports